module.exports = __webpack_public_path__ + "static/media/sunbeam.a0a2f789.png";